import parseHtml from "@utils/parseHtml";
import { $ } from "@utils/select";

export default (data) => ({
  ...data,
  filters: null,

  async init() {
    const response = await fetch(`${this.url}?sections=collection-filter-json`);

    if (response.status !== 200) {
      console.error(response.statusText);
      return;
    }

    const json = await response.json();
    const $dom = parseHtml(json["collection-filter-json"]);
    const $script = $("#collection-filter-json", $dom);
    if (!$script) return;

    this.filters = JSON.parse($script.textContent);
    this.$dispatch("filterloaded");
  },
});
